import React, { useEffect } from 'react';
import Lenis from 'lenis';
import { useLocation } from 'react-router-dom';
import { shouldReduceExperience } from '../../lib/performance';
export function SmoothScroll({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  useEffect(() => {
    if (shouldReduceExperience()) return;
    const lenis = new Lenis({
      duration: 1,
      easing: value => Math.min(1, 1.001 - Math.pow(2, -10 * value)),
      smoothWheel: true
    });
    let frame = 0;
    const animate = (time: number) => {
      lenis.raf(time);
      frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [location.pathname]);
  return <>{children}</>;
}